import { TDiscountName } from '../../../lib/api/orders';

export const CONFIRMATION_URL = 'https://soundstudios.io/payment-confirmation';
